module.exports = __webpack_public_path__ + "static/media/uploadLogo.b420a3b5.svg";